/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Downgrade_Max_UsersInputs */



/**
* | output |
* | --- |
* | "Max users" |
*
* @param {Sub_Downgrade_Max_UsersInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_downgrade_max_users = /** @type {((inputs?: Sub_Downgrade_Max_UsersInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Downgrade_Max_UsersInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Max. Nutzer")
	return /** @type {LocalizedString} */ ("Max users")
});